import { Country } from './country';

export class Network {
    id: number|undefined;
    active:boolean;
    label:string;
    country:Country;
  }
  